/**
 * @fileOverview This file contains the implementation of the hook to manage the tour/tutorial in Clients module.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { Typography } from "@mui/material";
import { useTranslationHook } from "../hooks/UseTranslationHook";

const useClientsTour = (setModalCShow) => {
  const {
    clientsS1P1,
    clientsS1P2,
    clientsS2P1,
    clientsS2P2,
    clientsS3P1,
    clientsS3P2,
    clientsS3P3,
    clientsS3P4,
    clientsS3P5,
    clientsS4P1,
    clientsS5P1,
    clientsS5P2,
    clientsS6P1,
    clientsS6P2,
  } = useTranslationHook();

  return [
    {
      selector: ".create-client-tour",
      content: (
        <Typography>
          <strong>{clientsS1P1}</strong> {clientsS1P2}
        </Typography>
      ),
      action: () => setModalCShow(false),
      stepInteraction: false,
    },
    {
      content: (
        <Typography>
          {clientsS2P1} <strong>{clientsS2P2}</strong>.
        </Typography>
      ),
      action: () => setModalCShow(true),
      stepInteraction: false,
    },
    {
      selector: ".create-client-form-tour",
      content: (
        <Typography>
          {clientsS3P1} <strong>{clientsS3P2}</strong>. {clientsS3P3}{" "}
          <strong>{clientsS3P4}</strong> {clientsS3P5}
        </Typography>
      ),
      action: () => setModalCShow(true),
      stepInteraction: false,
    },
    {
      selector: ".create-client-contact-form-tour",
      content: (
        <Typography>
          {clientsS4P1}
        </Typography>
      ),
      action: () => setModalCShow(true),
      stepInteraction: false,
    },
    {
      selector: ".clients-datagrid-tour",
      content: (
        <Typography>
          {clientsS5P1} <strong>{clientsS5P2}</strong>.
        </Typography>
      ),
      action: () => setModalCShow(false),
      stepInteraction: false,
    },
    {
      selector: ".clients-datagrid-actions-tour",
      content: (
        <Typography>
          {clientsS6P1} <strong>{clientsS6P2}</strong>.
        </Typography>
      ),
      action: () => setModalCShow(false),
      stepInteraction: false,
    },
  ];
};

export default useClientsTour;
